import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import DataTableActions from "../../components/datatable/data-table-actions";
import DataTableBase from "../../components/datatable/data-table-base";
import {useTransactionService} from "../../services/transaction-service";
import AddEditTransactionModal from "./add-edit-transaction-modal";
import {AppRoutes, TransactionType} from "../../utils/constants";
import {Link} from "react-router-dom";
import FormatService from "../../services/format-service";

export default function TransactionsList () {
  let transactionService = useTransactionService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const addEditModal = useRef();

  useEffect(()=>{
    transactionService.getList()
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }, []);

  const onAddEditAction = (row=null, e=null)=>{
    addEditModal.current.openModal(row);
  };

  const onAddEditCallbackAction = (item=null)=>{
    const newItem = {...item, users_count: !item.users ? 0 : item.users.length };
    setRows(HelperService.addOrReplaceItemInList(rows,newItem));
  };

  const onDelAction = (item, e=null)=>{
    if (true===confirm('Naozaj odstrániť záznam?')){
      transactionService.delModel(item.id)
        .then(()=>{
          setRows(HelperService.removeItemFromList(rows,item));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const columns = [{
    name: 'Dátum',
    selector: row => row.value_at,
    format: row => { return HelperService.formatDate(row.value_at) },
    sortable: true,
  },{
    name: 'Člen',
    selector: row => row?.user?.name,
    format: row => <Link to={`${AppRoutes.users.path}/${row?.user?.id}`}>{row?.user?.name}</Link>,
    filterSelector: row => row?.user?.name,
    sortable: true,
  },{
    name: 'Hodnota',
    format: row => row.type===TransactionType.credit.val
      ? FormatService.formatNumber(row.value, 'EUR')
      : FormatService.formatNumber(-row.value, 'EUR'),
    selector: row => row.value,
    sortable: true,
  },{
    name: 'Typ',
    center: true,
    selector: row => row.type,
    format: row => row.type===TransactionType.credit.val
        ? <span className="badge badge-lg bg-success"><span title="Vklad" className="mdi mdi-plus-circle-outline"></span> Vklad</span>
        : <span className="badge badge-lg bg-danger"><span title="Výber" className="mdi mdi-minus-circle-outline"></span> Výber</span>,
    filterSelector: row => { return row.type === TransactionType.credit.val? 'Vklad' : 'Výber'},
    sortable: true,
  },{
    name: 'Členské podiely',
    selector: row => row.membership_share.value,
    sortable: true,
  },{
      name: 'Interná hodnota',
      format: row => FormatService.formatNumber(row.membership_share?.internal_value?.value, 'EUR'),
      selector: row => row.membership_share?.internal_value?.value,
      sortable: true,
    },{
    cell: row => <DataTableActions row={row} actions={[
      {title: 'Upraviť', icon: <span className="mdi mdi-book-edit-outline"></span>, action: onAddEditAction, className: 'hover-text-primary'},
      {title: 'Zmazať', icon: <span className="mdi mdi-trash-can-outline"></span>, action: onDelAction, className: 'hover-text-danger'},
    ]} />,
    allowOverflow: true,
    button: true,
  }];

  return (
    <>
      <AddEditTransactionModal ref={addEditModal} onSuccess={onAddEditCallbackAction} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Prehľad vkladov a výberov</PageTitle>

          <button className="btn btn-primary mb-2" onClick={(e)=>onAddEditAction(null, e)}><span className="mdi mdi-plus"></span> Pridať</button>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                 <DataTableBase
                    progressPending={!loaded}
                    columns={columns}
                    data={rows}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

TransactionsList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

TransactionsList.getSEO = function getSEO() {
  return {
    title: "Transakcie",
  }
}
